import React from "react";
import { Link } from "react-router-dom";

const AuthFooter = ({ question, linkText, linkTo }) => {
  return (
    <div className="mt-12 pt-8 border-t border-slate-100 dark:border-white/5 text-center">
      <p className="text-slate-500 dark:text-slate-400 text-sm font-medium">
        {question}{" "}
        <Link 
          to={linkTo} 
          className="text-blue-600 dark:text-blue-400 font-black hover:underline ml-1 uppercase tracking-wider"
        >
          {linkText}
        </Link>
      </p>
    </div>
  );
};

export default AuthFooter;